import httpService from "./http.service";

class CommonService {
  uploadImage = (file) => {
    const formData = new FormData();
    formData.append("image", file);
    return httpService.form("/common/upload_image", formData, "uploadImage");
  };
}

const commonService = new CommonService();
export default commonService;
